import { Stack } from '@mui/material';
import React from 'react';

const FormFooter = ({ children }: { children: React.ReactNode }) => {
    return (
        <Stack
            sx={{
                position: 'fixed',
                bottom: '0',
                left: '0',
                width: '100%',
                padding: 2,
                background: 'white',
                alignItems: 'flex-end',
                justifyContent: 'center',
                zIndex: '99',
            }}
            padding={3}
        >
            {children}
        </Stack>
    );
};

export default FormFooter;
